import type { HttpClient } from '../../../types/api';
import type { APIResponse } from '../../../types/api';

export type PostProfileParams = {
  name: string;
  profile?: string;
  file?: File;
};

export interface PostProfileFormData extends FormData {
  append(name: keyof PostProfileParams, value: string | Blob, fileName?: string): void;
}

export type PostProfileResponse = APIResponse<null>;

export const postProfile = async (
  formData: PostProfileFormData,
  httpClient: HttpClient,
): Promise<PostProfileResponse> => {
  return await httpClient.post<PostProfileResponse>('/user/v1/profile', {
    body: formData,
    headers: {},
  });
};
